import axios from "axios";
import { API } from "./apiConfig";

const authHeader = () => ({ withCredentials: true });

export const postUserAuditEvent = async (event) => {
  const { data } = await axios.post(`${API}/user-audit-log`, event, {
    ...authHeader(),
    suppressGlobalLoader: true,
  });
  return data;
};

export const getUserAuditLog = async (params = {}) => {
  const { data } = await axios.get(`${API}/admin/user-audit-log`, {
    ...authHeader(),
    params,
  });
  return data;
};

export const getProductAnalytics = async (params = {}) => {
  const { data } = await axios.get(`${API}/admin/product-analytics`, {
    ...authHeader(),
    params,
  });
  return data;
};
